//20250602 axa inici
import { HttpClient } from '@angular/common/http';
//20250602 axa final

import { EventEmitter, Injectable, Output } from '@angular/core';
//20250602 axa inici
//import { BehaviorSubject, Observable } from 'rxjs';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
//20250602 axa final
import { environment } from 'src/environments/environment.prod';
declare const $ : any;

@Injectable({
  providedIn: 'root'
})
export class HeaderService {
  private _showLogin : BehaviorSubject<boolean>;
  private _showSlide : BehaviorSubject<boolean>;
  private _showNavigation : BehaviorSubject<boolean>;
  private _showFeatured : BehaviorSubject<boolean>;


  public showLogin : Observable<boolean>;
  public showSlide : Observable<boolean>;
  public showNavigation : Observable<boolean>;
  public showFeatured: Observable<boolean>;

  //20250602 axa inici
  //constructor() { 
  constructor(
    private http: HttpClient,
  ) {
 //20250602 axa final

    this._showLogin = new BehaviorSubject(true);
    this._showSlide = new BehaviorSubject(true);
    this._showNavigation = new BehaviorSubject(true);
    this._showFeatured = new BehaviorSubject(true);


    this.showLogin = this._showLogin.asObservable();
    this.showSlide = this._showSlide.asObservable();
    this.showNavigation = this._showNavigation.asObservable();
    this.showFeatured = this._showFeatured.asObservable();
   }

   setHeader (showLogin : boolean, showSlide: boolean, showNavigation: boolean, showFeatured: boolean)
   {
    if (this._showLogin.value  != showLogin)
      this._showLogin.next(showLogin);
    if (this._showSlide.value  != showSlide)
      this._showSlide.next(showSlide);
    if (this._showNavigation.value  != showNavigation)
      this._showNavigation.next(showNavigation);
    if (this._showFeatured.value  != showFeatured)
      this._showFeatured.next(showFeatured);
   }

   scrollTop (){
      $("html, body").stop().animate({scrollTop:0}, environment.PAGE_SCROLL_DELAY, 'swing');
   }

  scrollMain (){
    $("html, body").stop().animate({scrollTop: $("#main").offset().top }, environment.PAGE_SCROLL_DELAY, 'swing');
  }
  

}
